import logo from "./assets/images/venezuelacourier.jpg";
const config = {
  page: {
    logo: logo,
    color_base: "#FABB00",
    color_titles: "white",
    color_search_box: "#286DB4",
    btn_search_footer_color: "#FABB00",
    btn_search_icon: "",
    path: "http://venezuelacourier.cl/",
    company: "Venezuela Courier Spa",
    address: "San Martin 133, Santiago centro",
    email: null,
    phone: null,
    placeholderInput: "Ingrese guia ej. MAR-8000",
    prefijo: "MAR",
  },
  connect: {
    apiKey: "U2FsdGVkX1//mW4fUo+gSL9QEWfDO9Sx7SW7hJLlomLR/9+N16iAluIYSSmveogH",
    path: "https://api.dibox.dev/api/v1/tracking",
  },
  head: {
    title: (company) =>
      `Rastrea tu envio - ${company} - Envios a desde Chile hacia Venezuela`,
  },
};

export default config;
